import { render, staticRenderFns } from "./wx.vue?vue&type=template&id=22c4dd24"
import script from "./wx.vue?vue&type=script&lang=js"
export * from "./wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c4dd24')) {
      api.createRecord('22c4dd24', component.options)
    } else {
      api.reload('22c4dd24', component.options)
    }
    module.hot.accept("./wx.vue?vue&type=template&id=22c4dd24", function () {
      api.rerender('22c4dd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/wx.vue"
export default component.exports